import React from 'react';

const QuestionIcon = ({size}) => (
  <svg width={size} height={size} fill="none" viewBox={'0 0 21 21'}>
    <path fill="currentColor"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.58 10.5a7.92 7.92 0 1 1 15.84 0 7.92 7.92 0 0 1-15.84 0Zm5.94-3.38c.34-.47.81-.8 1.36-.95.34-.1.9-.1 1.24 0 .41.1.8.32 1.09.63.14.14.28.3.4.47.4.69.44 1.66.1 2.4-.15.3-.31.5-.84 1.05-.35.36-.46.5-.5.6-.01.07-.03.36-.03.65v.53H9.67l.01-.71c.01-.66.02-.73.1-.97.15-.44.3-.65.86-1.24.58-.6.62-.65.61-1.03 0-.47-.3-.78-.74-.78-.38 0-.67.24-.75.64l-.02.09H8.07l.02-.21c.04-.42.19-.83.43-1.17Zm1.19 6.11v1.67h1.6v-1.67H9.7Z"/>
  </svg>
);

export default QuestionIcon;
